import { useCallback, useEffect, useRef, useState } from 'react'

const EVENTS = [
  'mousemove',
  'mousedown',
  'keydown',
  'touchstart',
  'scroll'
] as const
const FOUR_SECONDS_IN_MILLISECONDS = 4000

type IdleHookResult = {
  isIdle: boolean
  cancelIsIdle: () => void
}

export default function useIdle(
  timeout: number = FOUR_SECONDS_IN_MILLISECONDS
): IdleHookResult {
  const [isIdle, setIsIdle] = useState(false)
  const timeoutHandler = useRef<NodeJS.Timeout>()

  const handleEvent = useCallback(() => {
    setIsIdle(false)
    clearTimeout(timeoutHandler.current)
    timeoutHandler.current = setTimeout(() => {
      setIsIdle(true)
    }, timeout)
  }, [timeout])

  const cancelIsIdle = useCallback(() => {
    clearTimeout(timeoutHandler.current)
    EVENTS.forEach(event => {
      window.removeEventListener(event, handleEvent)
    })
  }, [handleEvent])

  useEffect(() => {
    EVENTS.forEach(event => {
      window.addEventListener(event, handleEvent)
    })

    return () => {
      cancelIsIdle()
    }
  }, [handleEvent, cancelIsIdle])

  return { isIdle, cancelIsIdle }
}
